import { Abacus } from "core/Abacus.Core";

$.fn.parseClass = function(name) {
	var details = this.data('details') || this.attr('class') || '';
	var regex = new RegExp("^.*(\{.*\}).*$", "gi");
	var obj = details.match(regex) ? eval('(' + details.replace(regex, "$1") + ')') : {};
	if (name) return obj[name] || false;
	else return obj;
};

$.fn.makeTabbed = function(blocks, tabs) {
	var context = $(this);
	var tabBlocks = context.find(blocks);
	var tabList = tabBlocks.parent().attr("role","tablist");
	var tab = context.find(tabs).attr({
		tabindex: "0",
		role:"tab"});
	var selectTab = function () {
		tab.removeClass('selected');
		tabBlocks.removeClass('selected');
		$(this).parent().addClass('selected');
	};
	tab.on({
		'click': selectTab,
		'focus': selectTab
	});
	return this;
};

$.fn.makePlaceholder = function(){
	var context = $(this);
	var text = context.data('text') || context.parseClass('text');
	var form = context.closest('form');
	context.on({
		'focus': function(){
			if ($(this).val() == text) {
				$(this).val('');
			}
			$(this).removeClass('placeholder-on');
		},
		'blur': function(){
			if ($(this).val() == '' || $(this).val() == text) {
				$(this).val(text);
				$(this).addClass('placeholder-on');
			}
		}
	});
	if (form){
		var self = this;
		form.on('submit', function(){
			if ($(self).val() == text) $(self).val('');
		});
	}
	if (context.val() == ''){
		context.val(text);
	}
};

$.fn.makeExpandable = function(number){
	var context = $(this);
	var type = context.data('typeid') || context.parseClass('typeid') || 'default';
	var more = Abacus.Lang.core.more[type];
	var less = Abacus.Lang.core.less[type];
	var show = Abacus.Lang.core.show[type];
	var hide = Abacus.Lang.core.hide[type];
	var expand = {
		init: function(context, number){
			var self = this;
			this.element = $(context);
			this.number = number;
			this.tag = this.getTag();
			if(this.tag==="UL"){
				this.getLIs();
			} else {
				this.element.addClass('toggleContent');
				var span = this.createSpan('toggleContent', 'hidden', hide, hide, show);
				this.element.prepend(span);
			}
			
		},

		toggleContent: function(klass, toggle, m1, m2) {
			var text = ($(this).prev('.toggleContent').hasClass(toggle)) ? m1 : m2;
			$(this).html(text);
			$(this).prev('.toggleContent').toggleClass(toggle);
		},

		createSpan: function(klass, toggle, startm, m1, m2) {
			var self = this;
			return $("<span class='more' tabindex='0'>"+startm+"</span>").on({
				'click': function(){
					self.toggleContent.call(this, klass, toggle, m1, m2);
				},
				'keydown': function(evt){
					if(evt.keycode == '13'){
						self.toggleContent.call(this, klass, toggle, m1, m2);
					}
				}
			});
		},

		getTag: function() {
			return this.element.prop("tagName");
		},

		getLIs: function() {
			var self = this;
			this.element.find('li').each(function(i, li){
				if (i < self.number){
					$(li).addClass('always');
				} else if (i == self.number){
					var span = self.createSpan('toggleContent', 'collapsed', more, less, more);
					self.element.parent().append(span);
					self.element.addClass('toggleContent').addClass('collapsed');
				}
			});
		}
	}
	expand.init(context, number);
	return this;
};

$.fn.makeVideoBlock = function(){
	var context = $(this);
	context.html('<div></div>');
	var options = context.data('media') || context.parseClass();
	var movie = $.flash.create({
		swf: options.player,
		wmode: 'transparent',
		allowScriptAccess: 'always',
		quality: 'best',
		scale: 'exactfit',
		allowFullScreen: 'true',
		salign: 'TL',
		height: 1,
		width: 1,
		flashvars: {
			videoFile: options.src,
			beginOnFirstFrame: 'true'
		}
	});
	context.children().first().html(movie);
};

$.fn.openInNewWindow = function() {
	var context = $(this);
	var href = context.attr('href');
	context.on('click', function(e){
		e.preventDefault();
		window.open(href);
	});
	return this;
};

$.fn.embedContent = function() {
	var context = $(this);
	var text = decodeURIComponent(context.data('content'));
	var el = $("<div>" + text + "</div>");
	var last = context;
	el.children().each(function(i,child){
		$(last).after(child);
		last = child;
	});
	context.remove();
	setTimeout(function(){
		$.stripScripts(text, true);
	}, 0);
	return this;
};

$.fn.submitFormOnChange = function() {
	var element = $(this);
	var $form = element.parents("form");
	element.on("change", function(e) {
		$form.submit();
	});
	return this;
};




// WEBPACK FOOTER //
// ./Javascript/jquery/ElementHelpers/ElementHelpers.js